'use client'
import { SbBlokData, storyblokEditable } from '@storyblok/react/rsc'
import { FC, useEffect, useState } from 'react'

import styles from './Avatargroup.module.css'

// import { PhnxAvatargroup } from './Avatargroup'
// import { AvatargroupProps } from './Avatargroup'

interface AvatargroupBlokProps {
  blok: {
    advisers: any
  } & SbBlokData
  rels?: any
}

// TODO: This needs a storybook story but for launch its all here

const Avatargroup: FC<AvatargroupBlokProps> = ({ blok, rels }) => {
  const [advisers, setAdvisers] = useState<any[]>([])

  useEffect(() => {
    // fetch related advisors from rels
    const fetchAdvisers = async () => {
      if (blok.advisers && blok.advisers.length > 0) {
        const advisers = blok.advisers.map((uuid: any) => {
          return rels?.find((rel: any) => rel.uuid === uuid) as any
        })
        setAdvisers(advisers)
      }
    }
    fetchAdvisers()
  }, [blok.advisers, rels])

  return (
    <div {...storyblokEditable(blok)}>
      <div className={`${styles.avtargroup}`}>
        {advisers.map((adviser: any, index: number) => (
          <div key={index} className={styles.item}>
            {adviser?.content?.partnerImage?.filename && (
              <a className={styles.image} href={`/${adviser.full_slug}`}>
                <img src={adviser?.content?.partnerImage?.filename} alt="" />
                <span>View Profile</span>
              </a>
            )}
            <div className={styles.text}>
              <h2>{adviser?.name}</h2>
              <div>
                <p>{adviser?.content?.title}</p>
              </div>
              <div className={styles.services}>
                <ul>
                  {adviser?.content?.specialities?.map((service: any, index: number) => (
                    <li key={index}>{service}</li>
                  ))}
                </ul>
              </div>
            </div>
          </div>
        ))}
      </div>
    </div>
  )
}

export default Avatargroup
